<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-8">
        <h3 class="text-center">Relatório de Avaliação do Vendedor</h3>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4">
                    <label>Loja:</label>
                  </div>
                  <div class="col-md-4">
                    <label for>Data Referência:</label>
                  </div>
                  <div class="col-md-4"><label for="">Gerador Por:</label></div>
                </div>

                <div class="row">
                    <div class="col-md-4">{{ !form.branche_id ? 'TODAS' : store_branch}}</div>
                    <div class="col-md-4">
                      {{ !form.reference ? 'TODAS' : date_reference }}
                    </div>
                    <div class="col-md-4">{{ user_auth_name }}</div>
                </div>

                <div class="row">
                    <div class="col-sm-12">&nbsp;</div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label>Administradora</label>
                  </div>
                  <div class="col-md-4">
                    <label>Período</label>
                  </div>
                  <div class="col-md-4">
                    <label>Criado em</label>

                  </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        {{ !administrator_id_ ? 'TODAS' : administrator }}
                    </div>
                    <div class="col-md-4">{{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}</div>
                    <div class="col-md-4">{{ new Date() | moment('DD/MM/YYYY') }} às {{ new Date() | moment('H[:]mm[h]')}}</div>
                </div>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <table class="table b-table table-sm" id="tabela">
              <thead class="thead-dark">
                <tr>
                  <th>Vendedor</th>
                  <th class="text-center" style="background-color: darkgreen">Positivas</th>
                  <th class="text-center" style="background-color: darkgreen">%</th>
                  <th class="text-center" style="background-color: darkred">Negativas</th>
                  <th class="text-center" style="background-color: darkred">%</th>
                  <th class="text-center">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-for="(iterator, key) of sellers" :key="key">
                  <td><a href="javascript:void(0)" @click="details == iterator ? details = null : details = iterator">{{iterator.name}}</a></td>
                  <td class="text-center" style="background-color: rgba(0,255,0,0.2)">{{iterator.positivas || 0}}</td>
                  <td class="text-center" style="background-color: rgba(0,255,0,0.2)">{{Math.round( (iterator.positivas / iterator.total) * 100) || 0}}%</td>
                  <td class="text-center" style="background-color: rgba(255,0,0,0.2)">{{iterator.negativas || 0}}</td>
                  <td class="text-center" style="background-color: rgba(255,0,0,0.2)">{{Math.round(  (iterator.negativas / iterator.total) * 100 ) || 0}}%</td>
                  <td class="text-center">{{iterator.total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="details != null">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <table class="table b-table table-sm">
              <thead class="thead-light">
                <tr>
                  <th>Detalhes do Vendedor</th>
                  <th colspan="3">{{details.name}}</th>
                </tr>
              </thead>
              <thead class="thead-dark">
                <tr>
                  <th>Cliente</th>
                  <th class="text-center">Contrato</th>
                  <th class="text-center">Avaliação</th>
                  <th class="text-center">Texto</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-for="(iterator, key) of details.avaliacoes" :key="key" v-bind:style="{ backgroundColor: iterator.type == positiva ? 'rgba(0,255,0,0.2)' : 'rgba(255,0,0,0.2)'}">
                  <td>{{iterator.clients_name}}</td>
                  <td class="text-center">{{iterator.physical_proposal}}</td>
                  <td class="text-center"><b v-bind:style="{ color: iterator.type == positiva ? 'darkgreen' : 'darkred'}">{{iterator.type == positiva ? 'POSITIVA' : "NEGATIVA"}}</b></td>
                  <td class="text-center">{{iterator.text}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <!--button-- type="button" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>

import Vue from "vue";

const POSITIVA = 1;
const NEGATIVA = 0;

export default {
  components: {},
  computed: {
      user_auth_name(){
          return this.$store.state.auth.user.name.toUpperCase();
      },
      branches() {
          return this.$store.state.defaults.branches;
      },
      dates: {
          get() {
              var dates = [
                  { id: "sale_date", name: "Data da Venda" },
                  { id: "due_date", name: "Data de Vencimento" },
                  { id: "payday", name: "Data de Pagamento" }
              ];

              return dates;
          }
      },
  },
  data() {
    return {
        positiva: POSITIVA,
        moment: Vue.moment,
        administrator_id_ : null,
        date: null,
        end_at: null,
        form: {},
        init_at: null,
	    details: null,
	    sellers: [],
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getData(){
        var self = this;

        self.$root.$emit("onLoading");
        const response = self.$store.dispatch('reports/evaluations', self.form);

        response.then(function (res) {
            const sellers = {};

            for(let avaliacao of res){
                if(!sellers[avaliacao.user_id]){
                    sellers[avaliacao.user_id] = {
                        name: avaliacao.user_name,
                        avaliacoes: [],
	                    positivas: 0,
	                    negativas: 0,
	                    total: 0
                    }
                }

                sellers[avaliacao.user_id].avaliacoes.push(avaliacao);
                sellers[avaliacao.user_id].total++;

                if(avaliacao.type == POSITIVA){
                    sellers[avaliacao.user_id].positivas++;
                }else{
                    sellers[avaliacao.user_id].negativas++;
                }
            }

            self.sellers = Object.values(sellers);
            self.$root.$emit("onLoading");
        });

        response.catch(function () {
            self.$root.$emit("onLoading");
        });
    },
    print() {
      window.print();
    },
    excel() {
      var nome = "Relatório de Avaliação do Vendedor";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("tabela").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Avaliação do Vendedor";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    },
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);
    self.store_branch   = self.form.branche_id ? self.branches.find(item => item.id === self.form.branche_id).name.toUpperCase() : null;
    self.date_reference = self.form.reference  ? self.dates.find(item => item.id === self.form.reference).name.toUpperCase()     : null;
    self.administrator_id_ = self.form.administrator_id;
    self.getData();


    // self.date = self.dates.find(date => date.id === self.form.date_by).name;
    self.init_at = self.form.date_at[0];
    self.end_at = self.form.date_at[1];

  }
};
</script>
<style type="scss">
@media print {
  .dont-print {
    display: none;
  }
  .table .thead-dark th{
    color: #aaaaaa;
  }
}
</style>

<style scoped>

</style>
